import React, { useState, useEffect, useRef } from 'react';
import './ScoreboardOverlay.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

function pad(n) {
  return String(Math.max(0, n)).padStart(2, '0');
}

function formatTime(minute, second, period) {
  const totalSeconds = minute * 60 + second;
  if (period === 1 && totalSeconds > 45 * 60) {
    const added = totalSeconds - 45 * 60;
    return { main: '45:00', added: `+${pad(Math.floor(added / 60))}:${pad(added % 60)}` };
  }
  if (period === 2 && totalSeconds > 90 * 60) {
    const added = totalSeconds - 90 * 60;
    return { main: '90:00', added: `+${pad(Math.floor(added / 60))}:${pad(added % 60)}` };
  }
  return { main: `${pad(minute)}:${pad(second)}`, added: '' };
}

const ScoreboardOverlay = () => {
  const [state, setState] = useState(null);
  const [goal, setGoal] = useState(null); // { team: string, key: number }
  const prevScores = useRef({ home: null, away: null });
  const goalTimer = useRef(null);
  const pollRef = useRef(null);

  useEffect(() => {
    const fetchState = async () => {
      try {
        const res = await fetch(`${API_URL}/scoreboard/`);
        if (res.ok) {
          const data = await res.json();
          setState(data);

          const prev = prevScores.current;
          if (prev.home !== null) {
            if (data.homeScore > prev.home) {
              triggerGoal(data.home || 'Casa');
            } else if (data.awayScore > prev.away) {
              triggerGoal(data.away || 'Fora');
            }
          }
          prevScores.current = { home: data.homeScore, away: data.awayScore };
        }
      } catch {
        // silently ignore — keep last known state
      }
    };

    fetchState();
    pollRef.current = setInterval(fetchState, 1000);
    return () => clearInterval(pollRef.current);
  }, []);

  function triggerGoal(team) {
    clearTimeout(goalTimer.current);
    setGoal({ team, key: Date.now() });
    goalTimer.current = setTimeout(() => setGoal(null), 3000);
  }

  if (!state || state.visible === false) return null;

  const time = formatTime(state.minute, state.second, state.period);

  return (
    <>
      <div className="overlay-wrapper">
        <div className={`overlay${goal ? ' goal-active' : ''}`}>
          <div className="teamBox">
            <div className="redCards">
              {Array.from({ length: Math.max(0, Math.min(4, state.homeRedCards || 0)) }).map((_, i) => (
                <span key={i} className="redCard" />
              ))}
            </div>
            <div className="team">{state.home || 'POR'}</div>
          </div>

          <div className="score">{state.homeScore ?? 0} - {state.awayScore ?? 0}</div>

          <div className="teamBox">
            <div className="redCards">
              {Array.from({ length: Math.max(0, Math.min(4, state.awayRedCards || 0)) }).map((_, i) => (
                <span key={i} className="redCard" />
              ))}
            </div>
            <div className="team">{state.away || 'ESP'}</div>
          </div>

          <div className="timebox">
            <div className="mainTime">{time.main}</div>
            {time.added && <div className="addedTime">{time.added}</div>}
          </div>

          {goal && (
            <div className="goal-anim" key={goal.key}>
              <div className="goal-text">GOLO ({goal.team})</div>
            </div>
          )}
        </div>

        {state.stoppageTime > 0 && (
          <div className="stoppage-badge">+{state.stoppageTime}</div>
        )}
      </div>

    </>
  );
};

export default ScoreboardOverlay;
